import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, Subject } from 'rxjs';
import { AccountService } from '../../services/account.service';
import { PageableAccount } from '../../domain/account.model';
import { Warehouse } from '../../domain/warehouse.model';
import { ItemService } from '../../services/item.service';
import { ItemGroup } from '../../domain/inventory.model';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
    selector: 'app-scan-redirect-popup',
    templateUrl: './scan-redirect-popup.component.html',
    styleUrl: './scan-redirect-popup.component.scss',
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ScanRedirectPopupComponent {
  type: string;

  selectedWarehouse: any;
  selectedAccount: any;
  selectedItemGroup: any;
  lastQuery: string = '';
  searchAccountSubject = new Subject<string>();
  searchAccountQuery: string = '';

  warehouses: Warehouse[] = [
    {
      id: 1,
      name: 'Bodega Zapopan'
    }
  ];

  accounts: any[] = [];
  constArticlesRelease: string = 'articles-release'
  itemGroups: ItemGroup[] = [];

  constructor(private confirmationService: ConfirmationService, private route: ActivatedRoute, private accountService: AccountService,
    private router: Router, private location: Location, private itemService: ItemService, private messageService: MessageService) {
    this.type = this.route.snapshot.paramMap.get('type') || 'Articles';
    this.selectedWarehouse = this.warehouses[0];
  }

  ngOnInit(): void {
    this.searchAccountSubject.pipe(debounceTime(800)).subscribe(searchText => {
      this.searchAccountQuery = searchText;
      this.fetchAccounts();
    });
  }

  fetchAccounts() {
    this.accountService.searchAllAccounts(this.searchAccountQuery).subscribe((response: PageableAccount) => {
      this.accounts = response.content;
    });
  }

  fetchItemGroups() {
    if (this.type === this.constArticlesRelease) {
      this.itemService.getItemGroups(this.selectedAccount?.accountId, this.selectedWarehouse?.name).subscribe((response: ItemGroup[]) => {
        this.itemGroups = response;
      });
    }
  }

  loadAccounts(event: any) {
    this.searchAccountSubject.next(event.filter || '');
  }

  onAccountSelect(): void {
    this.fetchItemGroups();
  }

  onAccept() {
    if (this.selectedWarehouse && this.selectedAccount) {
      const path = ['/' + this.type];
      //this.router.navigate(path);

      this.router.navigate(path, {
        queryParams: {
          warehouse: this.selectedWarehouse?.name,
          accountName: this.selectedAccount?.name,
          accountId: this.selectedAccount?.accountId,
          itemGroupId: this.selectedItemGroup?.itemGroupId
        }
      });
    }
  }

  onDialogClose() {
    this.location.back();
  }

  get title(): string {
    const baseTitle = 'Seleccionar Destino de ';
    switch (this.type) {
      case 'article-scanner':
        return baseTitle + 'Artículos';
      case 'palletization':
        return baseTitle + 'Paletización';
      case 'articles-release':
        return baseTitle + 'Salidas';
      default:
        return 'Seleccionar Destino';
    }
  }

  deleteItemGroup(event: Event, itemGroup: ItemGroup): void {
    event.stopPropagation(); // Evita que se dispare el onChange del dropdown
    this.confirmationService.confirm({
      message: `¿Seguro que deseas eliminar el grupo "${itemGroup.name}"?`,
      header: 'Confirmar eliminación',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.itemService.deleteItemGroup(itemGroup.itemGroupId).subscribe({
          next: () => {
            this.itemGroups = this.itemGroups.filter(g => g.itemGroupId !== itemGroup.itemGroupId);
            this.messageService.add({
              severity: 'success',
              summary: 'Eliminado',
              detail: `Grupo "${itemGroup.name}" eliminado correctamente.`
            });
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se pudo eliminar el grupo.'
            });
          }
        });
      }
    });
  }


}
